import React from 'react'
import { useSelector } from 'react-redux'

export const PrintCertificateDoc = React.forwardRef((props, ref) => {

    const {
        certificateManagement:{certificateDetails}
    } = useSelector((state) => state.app)
  
  return (
    <div ref={ref}>
       <img style={{width: '100vw', height: '100vh', objectFit: 'contain'}} src={props.filePath} alt='Application document'/> 
       {/* <style type="text/css" media="print">
        {`
          @page {
            size: landscape;
          }
        `}
      </style> */}
    </div>   
  )
})
